import { computed, inject, Injectable, signal, Signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { IOption } from '@cardium/contracts';
import { EnvironmentOptionCodeToOption } from '../types';

@Injectable()
export class EnvironmentOptionStore {
  private readonly http = inject(HttpClient);

  private readonly _envOptions = signal<EnvironmentOptionCodeToOption>({});

  public readonly envOptionsMap: Signal<EnvironmentOptionCodeToOption> =
    this._envOptions.asReadonly();

  public readonly envOptions: Signal<IOption[]> = computed(() => {
    return Object.values(this._envOptions());
  });

  public async load(): Promise<void> {
    return lastValueFrom(
      this.http.get<IOption[]>('/api/core/option/global/env').pipe(
        map((options) => {
          return options.reduce((acc, opt) => {
            acc[opt.code] = opt;
            return acc;
          }, {} as EnvironmentOptionCodeToOption);
        }),
        tap((envMap) => this._envOptions.set(envMap)),
        catchError(() => of(void 0)),
      ),
    ).then(() => undefined);
  }
}
